var React = require('react');

function IconFailCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M512.3 63.9c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.2 445-445c0-245.7-199.2-445-445-445zM462.1 266c0-5.5 4.5-10 10-10h80.2c5.5 0 10 4.5 10 10v300c0 5.5-4.5 10-10 10h-80.2c-5.5 0-10-4.5-10-10V266zm52.5 497.1c-34 0-61.5-27.6-61.5-61.5s27.6-61.5 61.5-61.5 61.5 27.6 61.5 61.5-27.5 61.5-61.5 61.5z"}));
}

IconFailCircleSolid.displayName = "IconFailCircleSolid";

IconFailCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconFailCircleSolid;

IconFailCircleSolid.default = IconFailCircleSolid;
